import moment from 'moment';
import { formatInteger } from 'core/functions/formatNumber';

const checkingIsFullDay = (duration: number) => {
	return Math.floor(duration / 3600) % 24 === 0;
};

export const getOppoDate = (startDate: Date, endDate: Date, duration: number) => {
	const isFullDay = checkingIsFullDay(duration);

	const isVisibleEndDate = Math.floor(duration / 3600) >= 24;
	if (isVisibleEndDate) {
		if (isFullDay) {
			const adjustedEndDate = new Date(endDate.getTime() - 1000);

			return `${moment(startDate).format('MM/DD/YYYY')} - ${moment(adjustedEndDate).format('MM/DD/YYYY')}`;
		}
		return `${moment(startDate).format('MM/DD/YYYY')} - ${moment(endDate).format('MM/DD/YYYY')}`;
	}
	return `${moment(startDate).format('MM/DD/YYYY')}`;
};

export const getDurationDetails = (duration: number, format?: 'long' | 'medium' | 'short'): string => {
	const hours = Math.floor(duration / 3600);
	const minutes = Math.floor((duration % 3600) / 60);

	let resultHours = '';
	let resultMinutes = '';

	const formattedHours = formatInteger(hours);
	const formattedMinutes = formatInteger(minutes);

	switch (format) {
		case 'long':
			if (hours) resultHours = `${formattedHours} ${hours === 1 ? 'Hour' : 'Hours'} `;
			if (minutes) resultMinutes = `${formattedMinutes} Minutes`;
			break;

		case 'medium':
			if (hours) resultHours = `${formattedHours} ${hours === 1 ? 'hr' : 'hrs'} `;
			if (minutes) resultMinutes = `${formattedMinutes} min`;
			break;

		case 'short':
		default:
			resultHours = `${formatInteger(hours || 0)}h`;
			resultMinutes = `${formattedMinutes}m`;
			break;
	}

	return `${resultHours}${resultMinutes}`.toLowerCase();
};
